import axios from 'axios'
import { Vehicle, PostVehicle, UpdateVehicle, dropDown } from './interfaces'
import GetJsonData from './dataAccess'

const apiURL = process.env.REACT_APP_API_URL

export const getVehicles = async (): Promise<Vehicle[]> => {
  const data = await GetJsonData('vehicle')

  const vehicleData: Vehicle[] = (data as Vehicle[]).map((item: any) => ({
    vehicleId: item.vehicleId,
    registration: item.registration,
    make: item.make,
    model: item.model,
    employeeName: item.employeeName,
    employeeId: item.employeeId,
    purchaseTypeId: item.purchaseTypeId,
    vehicleTypeId: item.vehicleTypeId,
    taxDate: item.taxDate,
    motDate: item.motDate,
    motBooked: item.motBooked,
    serviceDate: item.serviceDate,
    hasTracker: item.hasTracker,
    serviceBooked: item.serviceBooked,
    mileage: item.mileage,
    leaseEndDate: item.leaseEndDate,
    leaseMonthlyPayment: item.leaseMonthlyPayment,
    dateReturnedSold: item.dateReturnedSold,
    archived: item.archived,
    createDate: item.createDate,
    employeeCreatedbyName: item.employeeCreatedbyName,
    modifiedDate: item.modifiedDate,
    employeeModifiedbyName: item.employeeModifiedbyName,
    isTaxDue: item.isTaxDue,
    isMOTDue: item.isMOTDue,
    costsToDate: item.costsToDate,
  }))

  return vehicleData
}

export const getVehicleById = async (vehicleId: number): Promise<Vehicle> => {
  const data = await GetJsonData(`vehicle/${vehicleId}`)
  return data as Vehicle
}

export const submitVehicle = async (vehicle: PostVehicle): Promise<void> => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      throw new Error('Authorization token not found');
    }
    
    const response = await axios.post(`https://${apiURL}/vehicle`, vehicle, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      }
    })
    return response.data
  } catch (error) {
    console.error('Error submitting vehicle:', error)
    throw error
  }
}

export const updateVehicle = async (vehicle: UpdateVehicle, vehicleId: number): Promise<void> => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      throw new Error('Authorization token not found');
    }
    
    const response = await axios.put(`https://${apiURL}/vehicle/${vehicleId}`, vehicle, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      }
    })
    return response.data
  } catch (error) {
    console.error('Error updating vehicle:', error)
    throw error
  }
}

export const deleteVehicle = async (vehicleId: number): Promise<void> => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      throw new Error('Authorization token not found');
    }
    
    const response = await axios.delete(`https://${apiURL}/vehicle/${vehicleId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      }
    })
    return response.data
  } catch (error) {
    console.error('Error deleting vehicle:', error)
    throw error
  }
}

// Dropdown data for purchase types
export const getPurchaseTypes = (): dropDown[] => {
  return [
    { value: 1, text: 'Owned' },
    { value: 2, text: 'Leased' }
  ]
}

// Dropdown data for vehicle types
export const getVehicleTypes = (): dropDown[] => {
  return [
    { value: 1, text: 'Car' },
    { value: 2, text: 'Van' },
    { value: 3, text: 'Tipper' },
    { value: 4, text: 'Other' }
  ]
}

// Get documents for a vehicle
export const getVehicleDocuments = async (vehicleId: number) => {
  const token = localStorage.getItem('authToken')
  const storedApiURL = localStorage.getItem('apiURL');
  const finalApiURL = storedApiURL || apiURL;

  if (!token) {
    throw new Error('Authorization token not found')
  }

  try {
    const response = await axios.get(
      `https://${finalApiURL}/vehicle/${vehicleId}/documents`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error fetching vehicle documents:', error)
    return []
  }
}